var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJimP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1047,-143.494)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3,-2.50612)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -1007,
    cy: 183,
    r: 37,
    style: {
      fill: "rgb(225,240,244)"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -1007,
    cy: 183,
    r: 37
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.09205,0,0,1.16707,-5811.81,-6952.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4400,6130C4400,6130 4389.25,6131.26 4384.85,6131.78C4383.8,6131.91 4383.02,6132.71 4383.05,6133.65C4383.18,6138.73 4383.6,6153.98 4383.65,6155.82C4383.65,6155.94 4383.65,6156.06 4383.64,6156.18C4383.56,6157.85 4382.9,6170.55 4382.63,6175.76C4382.6,6176.34 4382.84,6176.91 4383.3,6177.33C4383.75,6177.75 4384.38,6177.98 4385.04,6177.98C4391.51,6177.98 4408.66,6177.98 4415.13,6177.98C4415.79,6177.98 4416.42,6177.75 4416.87,6177.33C4417.33,6176.91 4417.57,6176.34 4417.54,6175.76C4417.27,6170.53 4416.61,6157.76 4416.53,6156.16C4416.52,6156.06 4416.52,6155.94 4416.52,6155.84C4416.56,6154.07 4416.86,6138.73 4416.97,6133.64C4416.99,6132.7 4416.21,6131.91 4415.16,6131.78C4410.77,6131.27 4400,6130 4400,6130Z",
    style: {
      fill: "rgb(219,124,60)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.530971,0,0,0.530971,-3398.32,-3292.21)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.98539,-6955.06,-11715.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6125L4395,6130C4398.33,6131.78 4401.67,6131.71 4405,6130L4404,6125L4396,6125Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6125L4395,6130C4398.33,6131.78 4401.67,6131.71 4405,6130L4404,6125L4396,6125Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.70294,0,1821.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6107.87C4390,6105.78 4390.67,6103.78 4391.86,6102.31C4393.05,6100.83 4394.66,6100 4396.34,6100L4403.66,6100C4405.34,6100 4406.95,6100.83 4408.14,6102.31C4409.33,6103.78 4410,6105.78 4410,6107.87L4410,6117.83C4410,6119.2 4409.5,6120.5 4408.64,6121.36C4407.09,6122.91 4404.55,6125.45 4402.61,6127.39C4401.09,6128.91 4398.91,6128.91 4397.39,6127.39C4395.45,6125.45 4392.91,6122.91 4391.36,6121.36C4390.5,6120.5 4390,6119.2 4390,6117.83L4390,6107.87Z",
    style: {
      fillOpacity: 0.11
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6952.45,-9375.42)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4391.5,
    cy: 6102,
    r: 2.5,
    style: {
      fill: "rgb(121,71,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6913.39,-9375.42)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4391.5,
    cy: 6102,
    r: 2.5,
    style: {
      fill: "rgb(121,71,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6955.06,-9380.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6108.77C4390,6103.93 4393.93,6100 4398.77,6100L4401.23,6100C4406.07,6100 4410,6103.93 4410,6108.77L4410,6117.9C4410,6119.25 4409.47,6120.53 4408.52,6121.48C4407.34,6122.66 4405.65,6124.35 4404.07,6125.93C4402.99,6127.01 4401.53,6127.61 4400,6127.61C4398.47,6127.61 4397.01,6127.01 4395.93,6125.93C4394.35,6124.35 4392.66,6122.66 4391.48,6121.48C4390.53,6120.53 4390,6119.25 4390,6117.9L4390,6108.77Z",
    style: {
      fill: "rgb(255,193,151)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6955.06,-9380.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6108.77C4390,6103.93 4393.93,6100 4398.77,6100L4401.23,6100C4406.07,6100 4410,6103.93 4410,6108.77L4410,6117.9C4410,6119.25 4409.47,6120.53 4408.52,6121.48C4407.34,6122.66 4405.65,6124.35 4404.07,6125.93C4402.99,6127.01 4401.53,6127.61 4400,6127.61C4398.47,6127.61 4397.01,6127.01 4395.93,6125.93C4394.35,6124.35 4392.66,6122.66 4391.48,6121.48C4390.53,6120.53 4390,6119.25 4390,6117.9L4390,6108.77Z",
    style: {
      fill: "rgb(255,193,151)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6955.06,-9380.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6108.77C4390,6103.93 4393.93,6100 4398.77,6100L4401.23,6100C4406.07,6100 4410,6103.93 4410,6108.77L4410,6117.9C4410,6119.25 4409.47,6120.53 4408.52,6121.48C4407.34,6122.66 4405.65,6124.35 4404.07,6125.93C4402.99,6127.01 4401.53,6127.61 4400,6127.61C4398.47,6127.61 4397.01,6127.01 4395.93,6125.93C4394.35,6124.35 4392.66,6122.66 4391.48,6121.48C4390.53,6120.53 4390,6119.25 4390,6117.9L4390,6108.77Z",
    style: {
      fill: "rgb(255,193,151)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6955.06,-9378.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4399.73,6112C4399.32,6112 4399,6112.32 4399,6112.73C4399,6113.34 4399,6114.2 4399,6114.67C4399,6114.76 4398.97,6114.84 4398.9,6114.9C4398.84,6114.97 4398.76,6115 4398.67,6115C4398.67,6115 4398.67,6115 4398.67,6115C4398.49,6115 4398.32,6115.07 4398.2,6115.2C4398.07,6115.32 4398,6115.49 4398,6115.67C4398,6115.86 4398,6116.08 4398,6116.27C4398,6116.68 4398.32,6117 4398.73,6117C4399.45,6117 4400.55,6117 4401.27,6117C4401.68,6117 4402,6116.68 4402,6116.27L4402,6115.67C4402,6115.49 4401.93,6115.32 4401.8,6115.2C4401.68,6115.07 4401.51,6115 4401.33,6115C4401.33,6115 4401.33,6115 4401.33,6115C4401.24,6115 4401.16,6114.97 4401.1,6114.9C4401.03,6114.84 4401,6114.76 4401,6114.67C4401,6114.2 4401,6113.34 4401,6112.73C4401,6112.32 4400.68,6112 4400.27,6112C4400.1,6112 4399.9,6112 4399.73,6112Z",
    style: {
      fill: "rgb(255,158,94)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6955.06,-9378.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6119L4404,6119L4404,6119C4404,6120.66 4402.66,6122 4401,6122C4400.35,6122 4399.65,6122 4399,6122C4397.34,6122 4396,6120.66 4396,6119C4396,6119 4396,6119 4396,6119Z",
    style: {
      fill: "rgb(46,18,0)"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6119L4404,6119L4404,6119C4404,6120.66 4402.66,6122 4401,6122C4400.35,6122 4399.65,6122 4399,6122C4397.34,6122 4396,6120.66 4396,6119C4396,6119 4396,6119 4396,6119Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6119L4404,6119L4404,6119.83C4404,6121.03 4403.03,6122 4401.83,6122C4400.69,6122 4399.31,6122 4398.17,6122C4396.97,6122 4396,6121.03 4396,6119.83C4396,6119.36 4396,6119 4396,6119Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.22465e-16,-1.22465e-16,-1,8800,12243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6119L4404,6119L4404,6119.83C4404,6121.03 4403.03,6122 4401.83,6122C4400.69,6122 4399.31,6122 4398.17,6122C4396.97,6122 4396,6121.03 4396,6119.83C4396,6119.36 4396,6119 4396,6119Z",
    style: {
      fill: "rgb(164,43,43)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6955.06,-9378.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4394,6110.78C4394,6110.35 4394.35,6110 4394.78,6110C4394.93,6110 4395.07,6110 4395.22,6110C4395.65,6110 4396,6110.35 4396,6110.78C4396,6111.23 4396,6111.77 4396,6112.22C4396,6112.65 4395.65,6113 4395.22,6113C4395.07,6113 4394.93,6113 4394.78,6113C4394.35,6113 4394,6112.65 4394,6112.22C4394,6111.77 4394,6111.23 4394,6110.78Z",
    style: {
      fill: "rgb(46,12,12)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6929.02,-9378.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4394,6110.78C4394,6110.35 4394.35,6110 4394.78,6110C4394.93,6110 4395.07,6110 4395.22,6110C4395.65,6110 4396,6110.35 4396,6110.78C4396,6111.23 4396,6111.77 4396,6112.22C4396,6112.65 4395.65,6113 4395.22,6113C4395.07,6113 4394.93,6113 4394.78,6113C4394.35,6113 4394,6112.65 4394,6112.22C4394,6111.77 4394,6111.23 4394,6110.78Z",
    style: {
      fill: "rgb(46,12,12)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6955.06,-9380.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4393,6109.5C4393,6109.37 4393.05,6109.24 4393.15,6109.15C4393.24,6109.05 4393.37,6109 4393.5,6109C4394.27,6109 4395.73,6109 4396.5,6109C4396.63,6109 4396.76,6109.05 4396.85,6109.15C4396.95,6109.24 4397,6109.37 4397,6109.5C4397,6109.63 4396.95,6109.76 4396.85,6109.85C4396.76,6109.95 4396.63,6110 4396.5,6110C4395.73,6110 4394.27,6110 4393.5,6110C4393.37,6110 4393.24,6109.95 4393.15,6109.85C4393.05,6109.76 4393,6109.63 4393,6109.5Z",
    style: {
      fill: "rgb(121,71,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6955.06,-9380.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4403,6109.5C4403,6109.37 4403.05,6109.24 4403.15,6109.15C4403.24,6109.05 4403.37,6109 4403.5,6109C4404.27,6109 4405.73,6109 4406.5,6109C4406.63,6109 4406.76,6109.05 4406.85,6109.15C4406.95,6109.24 4407,6109.37 4407,6109.5C4407,6109.63 4406.95,6109.76 4406.85,6109.85C4406.76,6109.95 4406.63,6110 4406.5,6110C4405.73,6110 4404.27,6110 4403.5,6110C4403.37,6110 4403.24,6109.95 4403.15,6109.85C4403.05,6109.76 4403,6109.63 4403,6109.5Z",
    style: {
      fill: "rgb(121,71,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6951.15,-9380.63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4391.5,
    cy: 6102,
    r: 2.5,
    style: {
      fill: "rgb(121,71,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6955.06,-9380.63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4396.5,
    cy: 6101,
    r: 2.5,
    style: {
      fill: "rgb(121,71,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6955.06,-9380.63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4402,
    cy: 6100,
    r: 4,
    style: {
      fill: "rgb(121,71,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6955.06,-9380.63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4407,
    cy: 6101.5,
    r: 3,
    style: {
      fill: "rgb(121,71,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6955.06,-9375.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4412,6110.03C4412,6109.75 4411.89,6109.49 4411.7,6109.3C4411.51,6109.11 4411.25,6109 4410.97,6109L4410,6109L4410,6113L4410,6113C4411.11,6113 4412,6112.11 4412,6111C4412,6110.66 4412,6110.32 4412,6110.03Z",
    style: {
      fill: "rgb(222,137,81)"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4412,6110.03C4412,6109.75 4411.89,6109.49 4411.7,6109.3C4411.51,6109.11 4411.25,6109 4410.97,6109L4410,6109L4410,6113L4410,6113C4411.11,6113 4412,6112.11 4412,6111C4412,6110.66 4412,6110.32 4412,6110.03Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.5,-1,3055.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4412,6113C4412,6110.79 4411.11,6109 4410,6109L4410,6109L4410,6113L4410.65,6113C4411.01,6113 4411.35,6112.72 4411.6,6112.21C4411.86,6111.7 4412,6111.01 4412,6110.29C4412,6109.58 4412,6109 4412,6113Z",
    style: {
      fill: "rgb(195,111,55)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60426,0,0,2.60426,-6955.06,-9375.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6109L4389,6109C4388.45,6109 4388,6109.45 4388,6110C4388,6110.3 4388,6110.65 4388,6111C4388,6112.11 4388.9,6113 4390,6113C4390,6113 4390,6113 4390,6113L4390,6109Z",
    style: {
      fill: "rgb(222,137,81)"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6109L4389,6109C4388.45,6109 4388,6109.45 4388,6110C4388,6110.3 4388,6110.65 4388,6111C4388,6112.11 4388.9,6113 4390,6113C4390,6113 4390,6113 4390,6113L4390,6109Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.5,1,3055.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6109L4388.64,6109C4388.28,6109 4388,6109.57 4388,6110.27L4388,6110.28C4388,6111.78 4388.61,6113 4389.36,6113C4389.72,6113 4390,6113 4390,6113L4390,6109Z",
    style: {
      fill: "rgb(195,111,55)"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.373218,0.702257,-1.49734,0.762761,6567.83,-7541.29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4386.79,6134.84C4386.79,6134.7 4386.67,6134.57 4386.46,6134.48C4386.26,6134.39 4385.98,6134.34 4385.69,6134.35C4382.12,6134.46 4370.8,6134.82 4366.58,6134.95C4365.67,6134.98 4364.97,6135.33 4364.97,6135.77C4364.97,6136.77 4364.97,6138.51 4364.97,6139.53C4364.97,6139.97 4365.7,6140.34 4366.64,6140.37C4370.92,6140.51 4382.21,6140.88 4385.73,6140.99C4386,6141 4386.28,6140.95 4386.48,6140.86C4386.68,6140.78 4386.79,6140.65 4386.79,6140.52C4386.79,6139.28 4386.79,6136.09 4386.79,6134.84Z",
    style: {
      fill: "rgb(219,124,60)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.414795,0.67953,1.44888,0.847734,-8102.54,-7963.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4386.79,6134.84C4386.79,6134.7 4386.67,6134.57 4386.46,6134.48C4386.26,6134.39 4385.98,6134.34 4385.69,6134.35C4382.12,6134.46 4370.8,6134.82 4366.58,6134.95C4365.67,6134.98 4364.97,6135.33 4364.97,6135.77C4364.97,6136.77 4364.97,6138.51 4364.97,6139.53C4364.97,6139.97 4365.7,6140.34 4366.64,6140.37C4370.92,6140.51 4382.21,6140.88 4385.73,6140.99C4386.01,6141 4386.28,6140.95 4386.48,6140.86C4386.68,6140.78 4386.79,6140.65 4386.79,6140.52C4386.79,6139.28 4386.79,6136.1 4386.79,6134.84Z",
    style: {
      fill: "rgb(219,124,60)"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJimP);
export default __webpack_public_path__ + "static/media/jim_p.5da3735e68ce694110aab51ad6fd414e.svg";
export { ForwardRef as ReactComponent };